import warningIconGradient from "@assets/images/exclamation.svg";
import { Box, Button, Dialog, makeStyles, Typography } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles(
  theme => ({
    contentFlex: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },

    buttonText: {
      fontSize: "18px",
      color: "white"
    },
    content: {
      fontFamily: "SCG",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "24px"
    },
    dialog: {
      width: "420px",
      padding: theme.spacing(3),
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
      borderRadius: "16px",
      display: "flex",
      flexDirection: "column",
      minHeight: "200px",
      justifyContent: "space-between"
    },
    title: {
      fontSize: "20px",
      fontWeight: 700
    },
    succcesType: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "12px",
      marginBottom: "12px"
    },
    errorText: {
      color: "#E41B17"
    },
    btnBackGroundGradient: {
      background:
        "linear-gradient(90deg, #601863 0%, #681661 12%, #81125C 32%, #A90C55 57%, #DF044A 86%, #FD0045 100%)",
      border: "none",
      color: "#ffffff",
      height: "48px",
      marginTop: "32px",
      "& .MuiTypography-root": {
        color: "#FFFFFF"
      },
      "&:hover": {
        border: "none"
      }
    }
  }),
  { name: "DialogSubmitBlock" }
);

export interface Props {
  isOpen: boolean;
  onClose: () => void;
  title?: string | React.ReactNode;
  content?: string | React.ReactNode;
  okText?: string;
  testId?: string;
}

const DialogSubmitBlock = ({
  isOpen,
  onClose,
  title,
  content,
  okText,
  testId
}: Props) => {
  const classes = useStyles();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        style: { borderRadius: 16 }
      }}
      data-testid={testId ?? "dialogSubmitBlock"}
    >
      <Box className={classes.dialog}>
        <div className={classes.contentFlex}>
          <img
            src={warningIconGradient}
            alt="Warning Icon"
            style={{ width: "40px", height: "40px" }}
          />
        </div>
        <div className={classes.succcesType}>
          <Typography className={classes.title}>
            {!!title ? title : "ไม่สามารถสร้างคำสั่งซื้อได้"}
          </Typography>
        </div>
        <div className={classes.contentFlex}>
          <Typography className={classes.content}>
            {!!content ? (
              content
            ) : (
              <>
                เนื่องจาก Item บางรายการ{""}
                <span className={classes.errorText}> ไม่มีราคา </span>
                <br />
                <span className={classes.contentFlex}>
                  กรุณาตรวจสอบอีกครั้ง
                </span>
              </>
            )}
          </Typography>
        </div>

        <Button
          id="confirmOrderButton"
          className={classes.btnBackGroundGradient}
          onClick={onClose}
        >
          <Typography className={classes.buttonText}>
            {!!okText ? okText : "ตกลงสั่งซื้อ"}
          </Typography>
        </Button>
      </Box>
    </Dialog>
  );
};

export default DialogSubmitBlock;
